import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, ExternalLink } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="border-t border-white/10 bg-black/80" itemScope itemType="https://schema.org/WPFooter">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          <div itemScope itemType="https://schema.org/Organization">
            <Link to="/" data-discover="true" className="flex items-center gap-2 mb-4">
              <img 
                src="/images/favicon.webp" 
                alt="Rouge Bets" 
                className="w-6 h-6"
                itemProp="logo"
              />
              <span className="text-xl font-bold bg-gradient-to-r from-toxic-green to-toxic-cyan bg-clip-text text-transparent" itemProp="name">
                Rouge Bets
              </span>
            </Link>
            <p className="text-white/70 text-sm" itemProp="description">
              Votre comparateur indépendant de sites de paris sportifs agréés en France.
            </p>
          </div>

         




          <div className="space-y-3 text-sm font-semibold uppercase tracking-wide">
            <p className="text-xs font-medium uppercase tracking-[0.25em] text-accent">Navigation</p>
            <Link to="/" data-discover="true" itemProp="url" className="block text-sky-100 transition hover:text-white">Accueil</Link>
            <Link to="/guides" data-discover="true" itemProp="url" className="block text-sky-100 transition hover:text-white">Guides</Link>
            <Link to="/reviews" data-discover="true" itemProp="url" className="block text-sky-100 transition hover:text-white">Avis</Link>
            <Link to="/news" data-discover="true" itemProp="url" className="block text-sky-100 transition hover:text-white">Actualités</Link>
          </div>
          <div className="space-y-3 text-sm font-semibold uppercase tracking-wide">
            <p className="text-xs font-medium uppercase tracking-[0.25em] text-accent">Légal</p>
            <Link to="/privacy-policy" data-discover="true" itemProp="url" className="block text-sky-100 transition hover:text-white">Politique de confidentialité</Link>
            <Link to="/terms" data-discover="true" itemProp="url" className="block text-sky-100 transition hover:text-white">Conditions générales</Link>
            <Link to="/cookies" data-discover="true" itemProp="url" className="block text-sky-100 transition hover:text-white">Politique cookies</Link>
            <Link to="/responsible-gaming" data-discover="true" itemProp="url" className="block text-sky-100 transition hover:text-white">Jeu responsable</Link>
          </div>
          <div className="space-y-4 text-sm font-semibold uppercase tracking-wide">
            <p className="text-xs font-medium uppercase tracking-[0.25em] text-accent">Jeu responsable</p>
            <div className="grid grid-cols-2 gap-3">
              <a
                  href="https://www.anj.fr/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center justify-center p-2 bg-gray-800 rounded-lg hover:bg-gray-700 transition"
              >
                <img src="/images/logo-anj.svg" alt="ANJ - Autorité Nationale des Jeux" className="h-12 w-auto object-contain" loading="lazy" decoding="async" />
              </a>
              <a
                  href="https://www.evalujeu.fr/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center justify-center p-2 bg-gray-800 rounded-lg hover:bg-gray-700 transition"
              >
                <img src="/images/evalu.svg" alt="EvaluJeu" className="h-12 w-auto object-contain" loading="lazy" decoding="async" />
              </a>
              <a
                  href="https://www.sosjoueurs.org/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center justify-center p-2 bg-gray-800 rounded-lg hover:bg-gray-700 transition"
              >
                <img src="/images/sos.svg" alt="SOS Joueurs" className="h-12 w-auto object-contain" loading="lazy" decoding="async" />
              </a>
              <a
                  href="https://www.sosjoueurs.org/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center justify-center p-2 bg-gray-800 rounded-lg hover:bg-gray-700 transition"
              >
                <img src="/images/18+.svg" alt="18+" className="h-12 w-auto object-contain" loading="lazy" decoding="async" />
              </a>
            </div>
            </div>
        </div>

        <div className="border-t border-white/10 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-white/60 text-xs text-center md:text-left">
              © 2025 Rouge Bets. Tous droits réservés. | Domain: rougebets.com
            </p>
            <div className="flex gap-6 text-xs text-white/60">
              <Link to="/terms" data-discover="true" className="hover:text-toxic-green transition-colors">
                Mentions légales
              </Link>
              <Link to="/privacy-policy" data-discover="true" className="hover:text-toxic-green transition-colors">
                Politique de confidentialité
              </Link>
            </div>
          </div>
          
          <div className="mt-6 pt-6 border-t border-white/10">
            <p className="text-white/60 text-xs leading-relaxed text-center">
              Rouge Bets est un site indépendant de comparaison et d'avis. Certains liens présents sur nos pages sont des liens d'affiliation, 
              ce qui signifie que nous pouvons recevoir une commission si vous cliquez ou vous inscrivez via ces liens. 
              Cela n'affecte jamais nos opinions, avis ou évaluations. Réservé aux personnes de 18 ans et plus. 
              Jouez de manière responsable - consultez{' '}
              <a href="https://www.joueurs-info-service.fr" target="_blank" rel="noopener noreferrer" className="text-toxic-green hover:underline">
                Joueurs Info Service
              </a>
              . Conditions générales applicables.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

